.container {
  display: block;
}

